// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d791f818","455":"d345b732","488":"f7ee2231"}[chunkId] + ".chunk.js";
};